<template>
	<div class="order-body">
		<ul class="store-setting-header">
			<span>
				<i class="el-icon-back" @click="goBack"></i>
			</span>
			<li>提成明细</li>
		</ul>
		<Search :ids="ids" :customList="customList" :staffList="staffList" :AuthorityList='AuthorityList' ref='searchRef' @modifySuc="modifySuc" @handleSearch="handleSearch" @exportExcel="exportExcel"/>
		<MainTable
			ref='table'
			:size='size'
			:page='page'
			:tableData='tableData'
			:totalCount='totalCount'
			:AuthorityList='AuthorityList'
			@modifySuc="modifySuc"
			@sortSearch="sortSearch"
			@handleSize='handleSizeChange'
			@handlePage='handlePageChange'
			@selectIds="selectIdsChange"
		/>
	</div>
</template>

<script>
import Search from '@/components/achievementDetail/Search.vue'
import MainTable from '@/components/achievementDetail/MainTable.vue'
export default {
	name: 'achievementDetail',
	components: {
		Search,
		MainTable
	},
	data () {
		return {
			dataValue: [],
			AuthorityList: {
				'11_0002_0001_00': false,
				'11_0002_0002_00': false,
				'11_0002_0003_00': false
			},
			dateValue: [],
			page: 1,
			size: 20,
			tableData: [],
			totalCount: 0,
			excelParams: {},
			ids: [],
			customList: [],
			staffList: [],
			customerCategoryId: '0',
			dateType: 0,
			number: '',
			staff: '',
			liquiDateFlag: -1,
			customer: '',
			product: '',
			spec: '',
			orderKey: '',
			orderBy: '',
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '13-2')
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		this.getCategory()
		this.getStaffName()
		this.getAuthority('11_0002_0000_00')
		this.openPage()
	},
	methods: {
		goBack () {
			window.sessionStorage.removeItem('achieveDetailSelect')
			this.$router.push('/main/achievement')
		},
		selectIdsChange (ids) {
			this.ids = ids
		},
		saveSelect () {
			let params = {
				dateValue: this.dateValue,
				beginDate: this.dateValue.length > 0 ? this.dateValue[0] : this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00',
				endDate: this.dateValue.length > 0 ? this.dateValue[1] : this.$fxUtils.getCurrentMonthLast() + ' 23:59:59',
				number: this.number,
				dateType: this.dateType,
				staff: this.staff,
				customer: this.customer,
				product: this.product,
				liquiDateFlag: this.liquiDateFlag,
				customerCategoryId: this.customerCategoryId,
				spec: this.spec,
				page: this.page,
				size: this.size
			}
			window.sessionStorage.setItem('achieveDetailSelect', JSON.stringify(params))
		},
		sortSearch (data) {
			this.orderKey = data.orderKey
			this.orderBy = data.orderBy
			this.excelParams.orderKey = data.orderKey
			this.excelParams.orderBy = data.orderBy
			this.findOrderList()
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		// 客户类别
		getCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result === true) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		// 员工名称
		getStaffName () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/result/staffname`
			}).then(res => {
				if (res.result === true) {
					this.staffList = res.data
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		openPage () {
			if (this.$route.query.staff) {
				this.staff = this.$route.query.staff
			}
			if (this.$route.query.dateValue) {
				this.dateValue = this.$route.query.dateValue
			}
			if (window.sessionStorage.getItem('achieveDetailSelect') && !this.filterFlag) {
				let data = JSON.parse(window.sessionStorage.getItem('achieveDetailSelect'))
				this.dateValue = data.dateValue
				this.number = data.number
				this.dateType = data.dateType
				this.customerCategoryId = data.customerCategoryId
				this.staff = data.staff
				this.customer = data.customer
				this.product = data.product
				this.liquiDateFlag = data.liquiDateFlag
				this.spec = data.spec
				this.page = data.page
				this.size = data.size
				this.excelParams = {
					beginDate: data.dateValue.length > 0 ? data.dateValue[0] : this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00',
					endDate: data.dateValue.length > 0 ? data.dateValue[1] : this.$fxUtils.getCurrentMonthLast() + ' 23:59:59',
					number: data.number,
					dateType: data.dateType,
					staffList: data.staff,
					customer: data.customer,
					product: data.product,
					liquiDateFlag: data.liquiDateFlag,
					customerCategoryId: data.customerCategoryId,
					spec: data.spec
				}
			} else {
				this.excelParams = {
					beginDate: this.dateValue.length > 0 ? this.dateValue[0] : this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00',
					endDate: this.dateValue.length > 0 ? this.dateValue[1] : this.$fxUtils.getCurrentMonthLast() + ' 23:59:59',
					number: this.number,
					dateType: this.dateType,
					staffList: this.staff,
					customer: this.customer,
					product: this.product,
					liquiDateFlag: this.liquiDateFlag,
					customerCategoryId: this.customerCategoryId,
					spec: this.spec
				}
			}
			this.findOrderList()
		},
		modifySuc () {
			this.$refs.table.clear()
			this.openPage()
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.findOrderList()
		},
		handlePageChange (value) {
			this.page = value
			this.findOrderList()
		},
		handleSearch (data) {
			this.$refs.table.clear()
			this.dateValue = data.dateValue
			this.number = data.number
			this.dateType = data.dateType
			this.customerCategoryId = data.customerCategoryId
			this.staff = data.staff
			this.customer = data.customer
			this.product = data.product
			this.liquiDateFlag = data.liquiDateFlag
			this.spec = data.spec
			this.page = 1
			this.excelParams = {
				beginDate: data.dateValue.length > 0 ? data.dateValue[0] : this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00',
				endDate: data.dateValue.length > 0 ? data.dateValue[1] : this.$fxUtils.getCurrentMonthLast() + ' 23:59:59',
				number: data.number,
				dateType: data.dateType,
				staffList: data.staff,
				customer: data.customer,
				product: data.product,
				liquiDateFlag: data.liquiDateFlag,
				customerCategoryId: data.customerCategoryId,
				spec: data.spec
			}
			if (!this.filterFlag) {
				this.saveSelect()
			}
			this.findOrderList()
		},
		// 导出
		exportExcel () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.urlQIV}/shop/commission/result/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			req.send(JSON.stringify(this.excelParams))
		},
		download (blobUrl, num) {
			const a = document.createElement('a')
			a.style.display = 'none'
			var date = new Date()
			var year = date.getFullYear()
			var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
			var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
			var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
			var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
			let name = '提成明细(' + year + month + day + hour + min + ').xls'
			a.download = name
			a.href = blobUrl
			a.click()
		},
		findOrderList () {
			this.tableData = []
			let staffIndex = this.staff.findIndex(item => {
				return item === ''
			})
			console.log(staffIndex)
			let copyStaff = this.$fxUtils.deepClone(this.staff)
			if (staffIndex !== -1) {
				copyStaff.splice(staffIndex, 1)
			}
			let params = {
				beginDate: this.dateValue.length > 0 ? this.dateValue[0] : this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00',
				endDate: this.dateValue.length > 0 ? this.dateValue[1] : this.$fxUtils.getCurrentMonthLast() + ' 23:59:59',
				page: this.page,
				size: this.size,
				number: this.number,
				dateType: this.dateType,
				staffList: copyStaff,
				customer: this.customer,
				product: this.product,
				liquiDateFlag: this.liquiDateFlag,
				customerCategoryId: this.customerCategoryId,
				spec: this.spec,
				orderKey: this.orderKey,
				orderBy: this.orderBy
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/resultlist`,
				data: params
			}).then(res => {
				this.totalCount = res.recordCount
				if (res.recordList !== null) {
					res.recordList.forEach(e => {
						if (!(String(e.productprice).indexOf('.') !== -1 && String(e.productprice).split('.')[1].length > 2)) {
							e.productprice = this.$fxUtils.toFixedSHW(e.productprice, 2)
						}
						if (!(String(e.realpaymoney).indexOf('.') !== -1 && String(e.realpaymoney).split('.')[1].length > 2)) {
							e.realpaymoney = this.$fxUtils.toFixedSHW(e.realpaymoney, 2)
						}
						if (!(String(e.commissionmoney).indexOf('.') !== -1 && String(e.commissionmoney).split('.')[1].length > 2)) {
							e.commissionmoney = this.$fxUtils.toFixedSHW(e.commissionmoney, 2)
						}
					})
				}
				this.tableData = res.recordList
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	flex: 1
	display flex
	flex-direction column
	.menu-box {
		height: 50px
		line-height: 50px
		text-indent: 30px
		text-align: left
		font-size: 15px
		border-bottom: 1px solid #dce1fe
		box-sizing: border-box
	}
	.store-setting-header {
		border-bottom: 1px solid #dce2fd;
		height:50px;
		line-height: 50px;
		font-size: 18px;
		box-sizing border-box
		span {
			float left
			display inline-block
			line-height 50px
			padding-right 20px
			i {
				border-radius: 50%;
				cursor: pointer;
				background: #9da6af;
				padding: 3px;
			}
			.el-icon-back {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
		li {
			margin-right 40px
			height: 100%
			box-sizing:border-box
			float left
		}
	}
	.shop-position {
		display flex
		align-items: center
		height: 50px
		min-height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-menu {
		height: 50px
		display flex
		position relative
		border-bottom: 1px solid #dce1fe
		li {
			height: 100%
			line-height: 49px
			margin-right: 60px
			font-size: 15px
			// font-weight: 700
			box-sizing:border-box
			cursor: pointer
			position: relative
			color: #595959
			&.active {
				color: var(--fx-primary-color)
				border-bottom: 2px solid var(--fx-primary-color)
			}
			span {
				position: absolute;
				width: 18px;
				height: 18px;
				line-height: 18px;
				border-radius: 50%;
				font-size: 11px;
				top: 5px;
				right: -18px;
				text-align: center;
				background-color: #EC4141;
				color: #fff;
				&.big-num {
					width: 28px;
					border-radius: 40px;
					right: -28px;
				}
			}
		}
		div {
			height: 100%
			line-height: 49px
			font-size: 14px
			font-weight: 700
			box-sizing:border-box
			position absolute;
			top: 0;
			right: 50px;
		}
	}
}
</style>
<style lang="stylus">
.order-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
